import React, { useState, useEffect } from 'react';

const SeoCheck = ({ status, text }) => {
  const icon = status === 'success' ? '✅' : status === 'error' ? '❌' : '🤔';
  const color = status === 'success' ? 'text-green-400' : status === 'error' ? 'text-red-400' : 'text-yellow-400';

  return (
    <li className={`flex items-center ${color}`}>
      <span className="mr-2">{icon}</span>
      <span>{text}</span>
    </li>
  );
};

const SeoAnalysis = ({ title, content, description, keywords }) => {
  const [focusKeyword, setFocusKeyword] = useState('');
  const [analysis, setAnalysis] = useState([]);

  useEffect(() => {
    const runAnalysis = () => {
      const newAnalysis = [];
      const cleanContent = content.replace(/<[^>]*>?/gm, ''); // Strip HTML tags
      const wordCount = cleanContent.split(/\s+/).filter(Boolean).length;

      // 1. Title Length
      if (title.length === 0) {
        newAnalysis.push({ status: 'error', text: 'Başlık boş bırakılamaz.' });
      } else if (title.length < 40) {
        newAnalysis.push({ status: 'warning', text: `Başlık çok kısa (${title.length} karakter). Önerilen 50-60 karakterdir.` });
      } else if (title.length > 65) {
        newAnalysis.push({ status: 'warning', text: `Başlık çok uzun (${title.length} karakter). Önerilen 50-60 karakterdir.` });
      } else {
        newAnalysis.push({ status: 'success', text: 'Başlık uzunluğu ideal.' });
      }

      // 2. Description Length
      if (description.length === 0) {
        newAnalysis.push({ status: 'error', text: 'Meta açıklama boş bırakılamaz.' });
      } else if (description.length < 120) {
        newAnalysis.push({ status: 'warning', text: `Meta açıklama çok kısa (${description.length} karakter). Önerilen 120-155 karakterdir.` });
      } else if (description.length > 160) {
        newAnalysis.push({ status: 'warning', text: `Meta açıklama çok uzun (${description.length} karakter). Önerilen 120-155 karakterdir.` });
      } else {
        newAnalysis.push({ status: 'success', text: 'Meta açıklama uzunluğu ideal.' });
      }

      // 3. Content Length
      if (wordCount < 300) {
        newAnalysis.push({ status: 'warning', text: `İçerik oldukça kısa (${wordCount} kelime). Daha uzun ve kapsamlı yazılar genellikle daha iyi sıralama alır.` });
      } else {
        newAnalysis.push({ status: 'success', text: `İçerik uzunluğu harika (${wordCount} kelime).` });
      }

      // 4. Focus Keyword Analysis
      if (focusKeyword) {
        const lowerFocusKeyword = focusKeyword.toLowerCase();
        // In title
        if (title.toLowerCase().includes(lowerFocusKeyword)) {
          newAnalysis.push({ status: 'success', text: 'Odak anahtar kelime başlıkta geçiyor.' });
        } else {
          newAnalysis.push({ status: 'error', text: 'Odak anahtar kelime başlıkta geçmiyor.' });
        }
        // In description
        if (description.toLowerCase().includes(lowerFocusKeyword)) {
          newAnalysis.push({ status: 'success', text: 'Odak anahtar kelime açıklamada geçiyor.' });
        } else {
          newAnalysis.push({ status: 'error', text: 'Odak anahtar kelime açıklamada geçmiyor.' });
        }
        // In content (first 10%)
        const first10Percent = cleanContent.substring(0, cleanContent.length * 0.1);
        if (first10Percent.toLowerCase().includes(lowerFocusKeyword)) {
          newAnalysis.push({ status: 'success', text: 'Odak anahtar kelime içeriğin başlangıcında geçiyor.' });
        } else {
          newAnalysis.push({ status: 'warning', text: 'Odak anahtar kelime içeriğin başlangıcında geçmiyor. Bu, SEO için önemli olabilir.' });
        }
      } else {
        newAnalysis.push({ status: 'info', text: 'SEO analizi için bir odak anahtar kelime girin.' });
      }

      setAnalysis(newAnalysis);
    };

    runAnalysis();
  }, [title, content, description, keywords, focusKeyword]);

  return (
    <div className="mt-6 bg-gray-900/70 border border-gray-700 rounded-xl p-6">
      <h4 className="text-lg font-semibold text-white mb-4">SEO Analizi</h4>
      <div className="mb-4">
        <label htmlFor="focusKeyword" className="block text-sm font-medium text-gray-300 mb-1">Odak Anahtar Kelime</label>
        <input 
          type="text" 
          id="focusKeyword" 
          value={focusKeyword}
          onChange={(e) => setFocusKeyword(e.target.value)}
          className="w-full bg-gray-800 border border-gray-600 rounded-md px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Analiz için anahtar kelime girin..."
        />
      </div>
      <ul className="space-y-2">
        {analysis.map((item, index) => (
          <SeoCheck key={index} status={item.status} text={item.text} />
        ))}
      </ul>
    </div>
  );
};

export default SeoAnalysis;
